interface TrendFilterBarProps {
  competitorOptions: string[];
  regionOptions: string[];
  countryOptions: string[];
  competitor: string;
  region: string;
  country: string;
  onCompetitorChange: (value: string) => void;
  onRegionChange: (value: string) => void;
  onCountryChange: (value: string) => void;
}

export function TrendFilterBar({
  competitorOptions,
  regionOptions,
  countryOptions,
  competitor,
  region,
  country,
  onCompetitorChange,
  onRegionChange,
  onCountryChange,
}: TrendFilterBarProps) {
  const cardStyle: React.CSSProperties = {
    backgroundColor: 'var(--color-background-primary)',
    borderColor: 'var(--color-system-quaternary)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 'var(--radius-xl)',
    boxShadow: 'var(--shadow-sm)',
  };
  const mutedText: React.CSSProperties = { color: 'var(--color-system-secondary)' };
  const inputStyle: React.CSSProperties = {
    borderColor: 'var(--color-system-quaternary)',
    backgroundColor: 'var(--color-background-primary)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 'var(--radius-md)',
  };

  return (
    <section className="p-4" style={cardStyle}>
      <div className="grid gap-3 md:grid-cols-3">
        <label className="block">
          <div className="mb-1 text-xs font-medium uppercase tracking-[0.18em]" style={mutedText}>
            Competitor
          </div>
          <select
            value={competitor}
            onChange={(e) => onCompetitorChange(e.target.value)}
            className="w-full px-3 py-2 text-sm outline-none focus:ring-2"
            style={inputStyle}
          >
            <option value="">全部竞品</option>
            {competitorOptions.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <div className="mb-1 text-xs font-medium uppercase tracking-[0.18em]" style={mutedText}>
            Region
          </div>
          <select
            value={region}
            onChange={(e) => onRegionChange(e.target.value)}
            className="w-full px-3 py-2 text-sm outline-none focus:ring-2"
            style={inputStyle}
          >
            <option value="">全部区域</option>
            {regionOptions.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <div className="mb-1 text-xs font-medium uppercase tracking-[0.18em]" style={mutedText}>
            Country
          </div>
          <select
            value={country}
            onChange={(e) => onCountryChange(e.target.value)}
            className="w-full px-3 py-2 text-sm outline-none focus:ring-2"
            style={inputStyle}
          >
            <option value="">全部国家</option>
            {countryOptions.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </label>
      </div>
    </section>
  );
}
